import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, map, Subject } from 'rxjs';
import { ProcessStepperService } from '../../process-stepper.service';
import { SignProcessWizardService } from '../../sign-process-wizard.service';
import { DocumentInfoModel } from './document-info-form/types/document-info-model';

@Injectable()
export class DocumentUploadStepService {

  private readonly _destroy = new Subject<void>();

  readonly documentInfoFormSubject = new BehaviorSubject<DocumentInfoModel>(undefined);
  readonly pdfDocumentsSubject = this._signProcessWizardService.pdfDocumentsSubject;

  readonly stepValidObs = this.pdfDocumentsSubject
    .pipe(
      map((pdfDocument) => Boolean(pdfDocument?.length)),
      distinctUntilChanged()
    )

  readonly triedNextObs = this._processStepperService.triedNextSubject.pipe(map(({ documentUpload }) => documentUpload));

  constructor(
    private _signProcessWizardService: SignProcessWizardService,
    private _processStepperService: ProcessStepperService
  ) {

  }

  ngOnDestroy() {

    this._destroy.next();
    this._destroy.complete();

    this.documentInfoFormSubject.complete();
  }
}
